import { render, staticRenderFns } from "./RiwayatPemasukan.vue?vue&type=template&id=2d79ac12&scoped=true"
import script from "./RiwayatPemasukan.vue?vue&type=script&lang=js"
export * from "./RiwayatPemasukan.vue?vue&type=script&lang=js"
import style0 from "./RiwayatPemasukan.vue?vue&type=style&index=0&id=2d79ac12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d79ac12",
  null
  
)

export default component.exports